import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHero } from "@/components/PageParts";
import { ArrowRight, Calendar } from "lucide-react";
import { api } from "@/lib/api";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/content/blog").then((r) => setPosts(r.data || [])); }, []);
  return (
    <div data-testid="page-blog">
      <PageHero
        eyebrow="Stories & Journal"
        title="Reflections on family, memory, and the craft of preserving them."
        image="https://images.pexels.com/photos/7854107/pexels-photo-7854107.jpeg"
        testid="blog-hero"
      />
      <section className="section-pad bg-offwhite">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10">
          {posts.map((p) => (
            <article key={p.id} className="bg-white rounded-xl overflow-hidden border border-border-warm hover:shadow-lg transition-shadow" data-testid={`blog-card-${p.slug}`}>
              {p.cover_url && <img src={p.cover_url} alt={p.title} className="w-full h-64 object-cover" />}
              <div className="p-8">
                <p className="eyebrow mb-3 flex items-center gap-2"><Calendar size={13} />{new Date(p.created_at).toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>
                <h2 className="font-serif text-2xl md:text-3xl mb-3">{p.title}</h2>
                <p className="text-warmgrey mb-5">{p.excerpt}</p>
                <Link to={`/blog/${p.slug}`} className="link-underline text-sm uppercase tracking-widest" data-testid={`blog-read-${p.slug}`}>Read more <ArrowRight size={14} /></Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/content/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <div className="pt-40 text-center text-warmgrey" data-testid="blog-not-found">Story not found.</div>;
  if (!post) return <div className="pt-40 text-center text-warmgrey">Loading...</div>;
  return (
    <div data-testid="page-blog-detail">
      <PageHero eyebrow="Story" title={post.title} image={post.cover_url || "https://images.pexels.com/photos/7854107/pexels-photo-7854107.jpeg"} testid="blog-detail-hero" />
      <article className="section-pad bg-offwhite">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="eyebrow mb-6">{new Date(post.created_at).toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })} · {post.author}</p>
          <div className="prose prose-lg max-w-none text-warmgrey text-lg leading-relaxed whitespace-pre-line">{post.body}</div>
          <Link to="/blog" className="link-underline mt-12 inline-flex text-sm uppercase tracking-widest">← Back to Stories</Link>
        </div>
      </article>
    </div>
  );
}
